module.exports = __webpack_public_path__ + "static/leader-step1.41ecc411.png";